import { render, staticRenderFns } from "./SelectedFormatTab.vue?vue&type=template&id=f5a26a70&"
import script from "./SelectedFormatTab.vue?vue&type=script&lang=ts&"
export * from "./SelectedFormatTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports